// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../node_modules/rescript/lib/es6/js_array.js";
import * as LocaleConstants$PorterinUtils from "../constants/LocaleConstants.mjs";

function getStrapiLocaleFromNextLocale(locale) {
  if (locale === LocaleConstants$PorterinUtils.en_BD) {
    return LocaleConstants$PorterinUtils.en;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return LocaleConstants$PorterinUtils.en_AE;
  } else if (locale === LocaleConstants$PorterinUtils.en_TR) {
    return LocaleConstants$PorterinUtils.en_TK;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return LocaleConstants$PorterinUtils.en_IN;
  } else if (locale === LocaleConstants$PorterinUtils.en_MY) {
    return LocaleConstants$PorterinUtils.en_MY;
  } else {
    return locale;
  }
}

function getNextLocaleFromStrapiLocale(locale) {
  if (locale === LocaleConstants$PorterinUtils.en) {
    return LocaleConstants$PorterinUtils.en_BD;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return LocaleConstants$PorterinUtils.en_AE;
  } else if (locale === LocaleConstants$PorterinUtils.en_TK) {
    return LocaleConstants$PorterinUtils.en_TR;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return LocaleConstants$PorterinUtils.en_IN;
  } else if (locale === LocaleConstants$PorterinUtils.en_MY) {
    return LocaleConstants$PorterinUtils.en_MY;
  } else {
    return locale;
  }
}

function getLanguageCodeFromNextLocale(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD) {
    return LocaleConstants$PorterinUtils.bn;
  } else if (locale === LocaleConstants$PorterinUtils.en_BD) {
    return LocaleConstants$PorterinUtils.en;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return LocaleConstants$PorterinUtils.en_AE;
  } else if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.en_TK) {
    return LocaleConstants$PorterinUtils.en_TR;
  } else if (locale === LocaleConstants$PorterinUtils.tr_TR) {
    return LocaleConstants$PorterinUtils.tr_TR;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return LocaleConstants$PorterinUtils.en_IN;
  } else if (locale === LocaleConstants$PorterinUtils.en_MY) {
    return LocaleConstants$PorterinUtils.en_MY;
  } else {
    return locale;
  }
}

function getLanguageCodeForOms(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD) {
    return LocaleConstants$PorterinUtils.bn;
  } else if (locale === LocaleConstants$PorterinUtils.en_BD || locale === LocaleConstants$PorterinUtils.en_AE || locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR) {
    return LocaleConstants$PorterinUtils.en;
  } else if (locale === LocaleConstants$PorterinUtils.tr_TR) {
    return LocaleConstants$PorterinUtils.tr;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN || locale === LocaleConstants$PorterinUtils.en_MY) {
    return LocaleConstants$PorterinUtils.en;
  } else {
    return locale;
  }
}

function localeToString(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD) {
    return LocaleConstants$PorterinUtils.bn_string;
  } else if (locale === LocaleConstants$PorterinUtils.en_BD || locale === LocaleConstants$PorterinUtils.en_AE || locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR) {
    return LocaleConstants$PorterinUtils.en_string;
  } else if (locale === LocaleConstants$PorterinUtils.tr_TR) {
    return LocaleConstants$PorterinUtils.tr_string;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN || locale !== LocaleConstants$PorterinUtils.en_MY) {
    return LocaleConstants$PorterinUtils.en_string;
  } else {
    return LocaleConstants$PorterinUtils.my_string;
  }
}

function isPageEnabledForLocaleUae(locale) {
  if (process.env.INFRA_STACK === "uae") {
    return locale === LocaleConstants$PorterinUtils.en_AE;
  } else {
    return false;
  }
}

function isPageEnabledForLocaleMalaysia(locale) {
  if (process.env.INFRA_STACK === "uae") {
    return locale === LocaleConstants$PorterinUtils.en_MY;
  } else {
    return false;
  }
}

function isPageEnabledForLocaleBd(locale) {
  if (process.env.INFRA_STACK === "uae") {
    if (locale === LocaleConstants$PorterinUtils.bn_BD) {
      return true;
    } else {
      return locale === LocaleConstants$PorterinUtils.en_BD;
    }
  } else {
    return false;
  }
}

function isPageEnabledForLocaleTurkey(locale) {
  if (process.env.INFRA_STACK === "uae") {
    if (locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR) {
      return true;
    } else {
      return locale === LocaleConstants$PorterinUtils.tr_TR;
    }
  } else {
    return false;
  }
}

function isPageEnabledForLocaleIndia(locale) {
  if (process.env.INFRA_STACK === "india") {
    return locale === LocaleConstants$PorterinUtils.en_IN;
  } else {
    return false;
  }
}

function isPageEnabledForLocaleIndiaPnM(param) {
  return process.env.INFRA_STACK === "india";
}

function isPageEnabledForLocaleIntPnM(param) {
  return process.env.INFRA_STACK === "uae";
}

function isPageEnabledForLocale(locale, page) {
  if (Js_array.includes(locale, [
          LocaleConstants$PorterinUtils.en_AE,
          LocaleConstants$PorterinUtils.en_IN,
          LocaleConstants$PorterinUtils.en_TR,
          LocaleConstants$PorterinUtils.tr_TR
        ])) {
    return true;
  } else {
    return false;
  }
}

function enableDesktopBookingFlow(locale) {
  return [
            LocaleConstants$PorterinUtils.en_AE,
            LocaleConstants$PorterinUtils.en_IN,
            LocaleConstants$PorterinUtils.en_TR,
            LocaleConstants$PorterinUtils.tr_TR
          ].includes(locale);
}

function enableMobileBookingFlow(locale) {
  return [
            LocaleConstants$PorterinUtils.en_AE,
            LocaleConstants$PorterinUtils.en_IN,
            LocaleConstants$PorterinUtils.en_TR,
            LocaleConstants$PorterinUtils.tr_TR
          ].includes(locale);
}

function isBkfEnabled(locale, is_desktop) {
  if (is_desktop && enableDesktopBookingFlow(locale)) {
    return true;
  } else if (is_desktop) {
    return false;
  } else {
    return enableMobileBookingFlow(locale);
  }
}

export {
  getStrapiLocaleFromNextLocale ,
  getNextLocaleFromStrapiLocale ,
  getLanguageCodeFromNextLocale ,
  getLanguageCodeForOms ,
  localeToString ,
  isPageEnabledForLocaleUae ,
  isPageEnabledForLocaleMalaysia ,
  isPageEnabledForLocaleBd ,
  isPageEnabledForLocaleTurkey ,
  isPageEnabledForLocaleIndia ,
  isPageEnabledForLocaleIndiaPnM ,
  isPageEnabledForLocaleIntPnM ,
  isPageEnabledForLocale ,
  enableDesktopBookingFlow ,
  enableMobileBookingFlow ,
  isBkfEnabled ,
}
/* No side effect */
